import React from 'react';
import PropTypes from 'prop-types';

export default function LastName({
  Field, Err, useInput, errors,
}) {
  return (
    <React.Fragment>
      <Field type="text" placeholder="last name" {...useInput('lastName', 'isRequired')} />
      {!!errors.lastName && <Err>Last name is required</Err>}
    </React.Fragment>
  );
}

LastName.propTypes = {
  Field: PropTypes.elementType.isRequired,
  Err: PropTypes.elementType.isRequired,
  useInput: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    lastName: PropTypes.string,
  }),
};

LastName.defaultProps = {
  errors: { lastName: null },
};
